<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'Address' | lang }}</div>
    </header>
    <div>
      <addresss :idx="idx" />
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import addresss from '@/components/Address.vue'

export default {
  name: 'AddressPage',
  mixins: [ page ],
  components: { addresss },
  props: ['idx'],
  data () {
    return {}
  },
  methods: {
    logout () {
      this.isLogged = false
      this.back()
    }
  },
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">


</style>
